import { render, staticRenderFns } from "./PrettyDate.vue?vue&type=template&id=4c6ae57c&"
import script from "./PrettyDate.vue?vue&type=script&lang=js&"
export * from "./PrettyDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrettyDate.vue"
export default component.exports